import styled from 'styled-components'

import Skeleton from './Skeleton'

export const WidthSkeleton = styled(Skeleton)`
  height: ${({ height }) => height};
  margin-right: ${({ mr }) => mr};
  margin-left: ${({ ml }) => ml};
  margin-bottom: ${({ mb }) => mb};
  width: ${({ width }) => width};
`
